import { render, staticRenderFns } from "./CustomerCustomerTransactionTable.vue?vue&type=template&id=57c7e4e4&scoped=true"
import script from "./CustomerCustomerTransactionTable.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerTransactionTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerTransactionTable.vue?vue&type=style&index=0&id=57c7e4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7e4e4",
  null
  
)

export default component.exports